import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import { history } from '@app/store'
import styles from '../index.module.scss'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import SocialButton from '../utility/social-button'
import config from '@config/index'
import Icon from '@components/icons'
import TwoFactorPopup from '../utility/twoFactorPopup'
import {
  clearCookies,
  removeAdminCookie,
  checkPermissionWOproduct,
  getReferralappUserData,
  getUserDataFromQuery,
  setCookiesV2,
  goToUpgradePlan
} from '@helpers/utility'
import { setHeader } from '@helpers/index'
import { segmentEventTrack, segmentGuestPageIdentify } from '@helpers/segment'
import moment from 'moment'
import { getAllQueryParam } from '@helpers/url'
import { ENTERPRISE_ROLES, USER_ROLES } from '@helpers/constants'
import qs from 'query-string'

const mapDispatchToProps = ({ auth, firstExperience, myaccount, accountsettings }) => {
  return {
    ...auth,
    firstExperience,
    myaccount, // don't spread this, since it'll override auth dispatch
    accountsettings
  }
}

const mapStateToProps = ({ auth, firstExperience, myaccount, accountsettings }) => {
  return {
    ...auth,
    firstExperience,
    myaccount, // don't spread this, since it'll override auth state
    accountsettings
  }
}

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAdditionalTesting: false,
      rerender: false,
      hidePassword: true,
      submitting: false,
      showTwoFAPopup: false,
      goToUpgradePage: false,
      initializing: true,
      firstName: '',
      lastName: '',
      contactPhone: ''
    }
  }
  componentDidMount() {
    // Beloew code is added as a part of prod testing.
    const key = 'legacy'
    const emailValidation = 'true'
    const queryResult = new URLSearchParams(this.props.location.search).get(key)
    const referralAppSource = new URLSearchParams(this.props.location.search).get('source')
    if (emailValidation !== queryResult) {
      const queryAllData = JSON.stringify(qs.parse(this.props.location.search))
      console.log('queryAllData', queryAllData)
      localStorage.setItem('campain_data', queryAllData)
      this.setState({ isAdditionalTesting: true })
      let redirectionUrl = config.incognito_redirect_url + 'login' + this.props.location.search
      if (referralAppSource) {
        redirectionUrl += '&source=' + referralAppSource
      }
      window.location.replace(redirectionUrl)
    } else {
      this.init()
    }
  }
  async init() {
    this.setState({ initializing: true })
    const queryData = getAllQueryParam()
    if (queryData && queryData.logout === 'true') {
      removeAdminCookie()
    }

    if (queryData && queryData.source) {
      this.props.setReferralApp(queryData.source)
      await this.props.getReferralAppProperties()
      const { referralAppsData = [] } = this.props
      if (referralAppsData && referralAppsData.length) {
        const { email } = getReferralappUserData(queryData, referralAppsData)
        this.setState({ initial_email: email })
      }
    }
    if (queryData && queryData.info) {
      const { email, firstName, lastName, phone } = getUserDataFromQuery(queryData)
      this.setState({
        initial_email: email,
        firstName: firstName,
        lastName: lastName,
        contactPhone: phone
      })
    }

    if (queryData && queryData.upgrade && queryData.upgrade === 'true' && queryData.plan) {
      if (queryData.plan === 'pro') {
        this.setState({ goToUpgradePage: true, queryData })
      }
    }

    this.props.clearApiError()

    setHeader(this.props.domainSettings, ' Login')

    const redirectAfterLogin =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.from &&
      this.props.location.state.from.search
        ? `${this.props.location.state.from.pathname}${this.props.location.state.from.search}`
        : ''

    const isPathExist =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.from &&
      this.props.location.state.from.pathname
        ? this.props.location.state.from.pathname
        : ''
    console.log('redirectAfterLogin===>', redirectAfterLogin)
    this.setState({ redirectAfterLogin, isPathExist, initializing: false })
  }
  async continueLogin(user) {
    if (this.props.user && !this.props.user.token) {
      await this.props.login({ ...this.state.loginCreds })
      await this.props.myaccount.getTimeZones({ nopaging: true })
      if (this.props.myaccount.timeZones && this.props.myaccount.timeZones.length) {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        const item = this.props.myaccount.timeZones.find((item) => item.key === userTimeZone)
        if (item && this.state.timezoneId && this.props.user && this.props.user._id) {
          this.props.accountsettings.updateAccountSettings({ userTimeZone: item._id, _id: this.props.user._id })
        }
      }
    }
    await this.props.getMe()
    const redirectionPath = this.getRedirectPath()
    this.setState({ submitting: false, redirectAfterLogin: redirectionPath })
    if (this.props.me) {
      if (this.props.me.company_settings && this.props.me.company_settings.new_update) {
        // this.openBrandingUpdate()
        this.loginRedirect()
      } else {
        this.loginRedirect()
      }
    }
  }
  userRoleIs(roles) {
    return this.props.user && this.props.user.role && roles.indexOf(this.props.user.role) > -1
  }

  getRedirectPath() {
    const path = localStorage.getItem('redirectPath')
    if (path !== null) {
      const parser = new URL(path)
      const redirectPath = parser.pathname + parser.search
      localStorage.removeItem('redirectPath')
      return redirectPath
    }
  }

  async loginRedirect() {
    console.log('=====loginRedirect=======', this.props, this.props.user, this.state)
    const { STAFF, READ_ONLY, CUSTOMER, TRIAL } = USER_ROLES
    const { PARTNER, MANAGER } = ENTERPRISE_ROLES
    if (this.props.user && this.props.user.isMultiLocation) {
      if (
        this.props.user.status === 'suspended' ||
        this.props.user.status === 'expired' ||
        this.props.user.status === 'deleted'
      ) {
        window.location.href = `/${this.props.user.uuid}/unauthorized`
      } else {
        if (this.state.redirectAfterLogin) {
          history.push(this.state.redirectAfterLogin)
        } else {
          if (this.props.user.total_accounts === 1) {
            history.push(`/${this.props.user.user_unique_id}/home`)
          } else {
            history.push(`/${this.props.user.user_unique_id}/analytics`)
          }
        }
        await this.SegmentTrack(this.props.user)
      }
    } else {
      if (this.state.goToUpgradePage && this.props.user && this.props.user.user_unique_id) {
        const { promo } = this.state.queryData
        const qs = `backHome=true${promo ? `&promo=${promo}` : ''}`
        await goToUpgradePlan(this.props.me, qs)
      } else if (this.userRoleIs([CUSTOMER, STAFF])) {
        // if (this.props.user.status === "new") {
        //     // open change password popup
        // }
        // else
        if (this.props.user.status === 'expired') {
          window.location.href = `/${this.props.user.uuid}/unauthorized`
        } else if (
          this.props.user.status === 'active' ||
          this.props.user.status === 'new' ||
          this.props.user.status === 'inactive' ||
          this.props.user.status === 'suspended'
        ) {
          if (this.props.user.yext_reauthenticate) {
            console.log('yext_reauthenticate==>,this.props.user.yext_reauthenticate')
            window.location.href = '/installation?reauthenticate=yes/unauthorized'
          } else {
            if (this.state.redirectAfterLogin) {
              if (this.state.redirectAfterLogin.indexOf(this.props.user.uuid) > -1) {
                if (
                  window.location.href.split('/login')[0] !== this.props.user.platform_url &&
                  window.location.href.split('/signup')[0] !== this.props.user.platform_url
                ) {
                  history.push(this.state.redirectAfterLogin)
                  // this.redirectToDomain(this.state.redirectAfterLogin, { key: "redirect", value: null });
                } else {
                  history.push(this.state.redirectAfterLogin)
                  // window.location.href = this.state.redirectAfterLogin;
                }
              } else {
                if (
                  window.location.href.split('/login')[0] !== this.props.user.platform_url &&
                  window.location.href.split('/signup')[0] !== this.props.user.platform_url
                ) {
                  history.push(this.state.redirectAfterLogin)
                  // this.redirectToDomain(this.state.redirectAfterLogin, { key: "redirect", value: null });
                } else {
                  history.push(this.state.redirectAfterLogin)
                  // window.location.href = "/" + this.props.user.uuid + "/" + this.state.redirectAfterLogin;
                }
              }
            } else if (this.state.isPathExist) {
              history.push(this.state.isPathExist)
            } else {
              const currentDomain = window.location.href.split('/login')[0]
              // redirection to enterprise domain
              if (currentDomain !== this.props.user.platform_url && process.env.REACT_APP_ENV === 'production') {
                this.redirectToDomain('/home')
                clearCookies(this.props.user.user_unique_id)
              } else {
                history.push(`/${this.props.user.user_unique_id}/home`)
              }
              await this.SegmentTrack(this.props.user)
            }
          }
        }
      } else if (this.userRoleIs([TRIAL, READ_ONLY])) {
        if (this.state.isPathExist) {
          history.push(this.state.isPathExist)
        } else if (this.props.user.instant_site && this.props.me && this.props.me.location_id) {
          history.push(`/${this.props.user.user_unique_id}/website/mywebsites`)
          await this.SegmentTrack(this.props.user)
        } else {
          if (
            window.location.href.split('/login')[0] !== this.props.user.platform_url &&
            window.location.href.split('/signup')[0] !== this.props.user.platform_url
          ) {
            history.push(`/${this.props.user.user_unique_id}/trial/home`)
            await this.SegmentTrack(this.props.user)
          } else {
            history.push(`/${this.props.user.user_unique_id}/trial/home`)
            await this.SegmentTrack(this.props.user)
          }
        }
      } else if (this.userRoleIs(['prospect'])) {
        history.push(`/${this.props.user.user_unique_id}/self-service`)
      } else {
        if (this.state.redirectAfterLogin) {
          if (this.state.redirectAfterLogin.indexOf(this.props.user.user_unique_id) > -1) {
            history.push(this.state.redirectAfterLogin)
          } else {
            if (
              window.location.href.split('/login')[0] !== this.props.user.platform_url &&
              window.location.href.split('/signup')[0] !== this.props.user.platform_url
            ) {
              history.push(this.state.redirectAfterLogin)
              // this.redirectToDomain(this.state.redirectAfterLogin, { key: "redirect", value: null });
            } else {
              if ([PARTNER, MANAGER].indexOf(this.props.user.role) > -1) {
                if (checkPermissionWOproduct('Admin.SiteAnalytics.View', this.props.me)) {
                  this.redirectToDomain('/analytics')
                } else {
                  this.redirectToDomain('/customers')
                }
              } else {
                if (checkPermissionWOproduct('Admin.SiteAnalytics.View', this.props.me)) {
                  this.redirectToDomain('/customers')
                } else {
                  this.redirectToDomain('/customers')
                }
              }
            }
          }
        } else {
          if (
            window.location.href.split('/login')[0] !== this.props.user.platform_url &&
            window.location.href.split('/signup')[0] !== this.props.user.platform_url
          ) {
            if ([PARTNER, MANAGER].indexOf(this.props.user.role) > -1) {
              if (checkPermissionWOproduct('Admin.SiteAnalytics.View', this.props.me)) {
                if (process.env.REACT_APP_ENV === 'development') {
                  history.push(`/${this.props.user.user_unique_id}/analytics`)
                } else {
                  this.redirectToDomain('/analytics')
                }
              } else {
                this.redirectToDomain('/customers')
              }
            } else {
              if (checkPermissionWOproduct('Admin.SiteAnalytics.View', this.props.me)) {
                this.redirectToDomain('/customers')
              } else {
                this.redirectToDomain('/customers')
              }
            }
          } else {
            if ([PARTNER, MANAGER].indexOf(this.props.user.role) > -1) {
              if (checkPermissionWOproduct('Admin.SiteAnalytics.View', this.props.me)) {
                if (process.env.REACT_APP_ENV === 'development') {
                  history.push(`/${this.props.user.user_unique_id}/analytics`)
                } else {
                  this.redirectToDomain('/analytics')
                }
              } else {
                this.redirectToDomain('/customers')
              }
            } else {
              if (checkPermissionWOproduct('Admin.SiteAnalytics.View', this.props.me)) {
                this.redirectToDomain('/customers')
              } else {
                this.redirectToDomain('/customers')
              }
            }
          }
        }
      }
    }
  }
  redirectToDomain(route, params) {
    console.log('Inside LOgin ============')
    let qs =
      '?t=' +
      this.props.user.token +
      '&s=' +
      this.props.user.status +
      '&r=' +
      this.props.user.role +
      '&uuid=' +
      this.props.user.user_unique_id
    let url = ''
    if (params) qs += '&' + params.key + '=' + params.value

    if (this.props.user.instant_url) {
      url = window.location.origin + '/home' + qs
    } else {
      url = window.location.origin + '/' + this.props.user.user_unique_id + route + qs
    }
    // clearCookies(this.props.user.user_unique_id)
    window.open(url, '_parent')
  }

  async handleSubmit(values) {
    await setCookiesV2('user_email', values.email)
    this.setState({ submitting: true })
    // delete values["remember_me"]
    if (this.props.referralApp) {
      values.source = this.props.referralApp
    }
    await this.props.login(values)
    this.setState({ loginCreds: values })
    if (this.props.user && !this.props.apiError) {
      if (this.props.user.two_factor_auth) {
        console.log('two_factor_auth===>', this.props.user.two_factor_auth)
        this.setState({ twoFactorData: this.props.user, showTwoFAPopup: true })
      } else {
        this.continueLogin(this.props.user)
      }
    } else {
      this.setState({ submitting: false })
    }
  }
  async onResendtOtp(payload) {
    await this.props.onResendtOtp(payload)
  }
  async verifyOtp(payload) {
    await this.props.verifyOtp(payload)
    if (!this.props.apiError) {
      this.setState({ showTwoFAPopup: false })
      this.continueLogin(this.props.user)
      await this.SegmentTrack(this.props.user)
    }
  }
  onSocialError() {
    this.setState({ rerender: true }, () => {
      this.setState({ rerender: false })
    })
  }
  async onSocialSubmit(user, method) {
    await setCookiesV2('user_email', user._profile.email)

    if (method === 'google') {
      await this.props.googleAuth({
        idToken: user._token.idToken,
        isLogin: true,
        forceSignup: true,
        cred: {
          name: user._profile.name,
          sub: user._profile.id
        }
      })
    }
    if (method === 'facebook') {
      await this.props.facebookAuth({
        yextDetails: 'No yext data',
        accessToken: user._token.accessToken,
        name: user._profile.name,
        forceSignup: true,
        redirectUri: 'http://localhost:3000/login',
        isLogin: true,
        clientId: config.facebook_client_id
      })
    }

    if (this.props.user) {
      if (window.location.hostname.indexOf('gosite.com') >= 0) {
        window.fbq(['track', 'GSFreeTrialSignup'])
      }

      if (this.props.user.two_factor_auth) {
        console.log('two_factor_auth===>', this.props.user.two_factor_auth)
        this.setState({ twoFactorData: this.props.user, showTwoFAPopup: true })
      } else {
        this.continueLogin(this.props.user)
      }
      await this.SegmentTrack(this.props.user)
    }
  }
  async SegmentTrack(user) {
    await segmentGuestPageIdentify(user)
    let data = {}
    let isMobile = false
    const today = new Date()
    const time = moment(today).format('LT')
    const date = moment(today).format('L')
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
      /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform)
    ) {
      isMobile = true
    } else {
      isMobile = false
    }
    data = {
      event: 'login',
      properties: {
        device: isMobile ? 'Mobile' : 'Desktop',
        date: date,
        time: time,
        app_source: this.props.referralApp ? this.props.referralApp : ''
      }
    }
    segmentEventTrack(data)
  }

  render() {
    const { rerender } = this.state
    const domainSettings = this.props.domainSettings
    // Beloew code is added as a part of prod testing.
    return (
      !this.state.isAdditionalTesting && (
        <div
          className={`position-relative py-30 d-flex align-items-center ${styles['page-auth']} ${styles['page-login']}`}>
          <div className={`mx-auto text-center pt-30 ${styles['master-form']}`}>
            <header className={`${styles['header']}`}>
              <Link className="d-inline-block" to="/login">
                <img
                  className={`${styles['auth-logo']} ${
                    domainSettings && domainSettings.logoUrl ? `${styles['auth-enterprise-logo']}` : ''
                  }`}
                  src={
                    domainSettings && domainSettings.logoUrl
                      ? domainSettings.logoUrl
                      : 'https://dufzo4epsnvlh.cloudfront.net/image/signup/gosite-logo-dark.svg'
                  }
                  alt=""
                />
              </Link>
            </header>
            {
              <div className={'border-0 shadow-xl mb-20 mt-30 ' + styles['content']}>
                <h2 className="mb-30" id="loginTitle" data-test="login-title">
                  Sign in to your account
                </h2>
                <div className="mb-20">
                  {!rerender ? (
                    <SocialButton
                      googleText="SIGN IN WITH GOOGLE"
                      fbText="SIGN IN WITH FACEBOOK"
                      googleCustomClass="mb-20 btn-google-custom"
                      fbCustomClass="btn-fb-custom border-0 text-white"
                      showItems={['facebook', 'google']}
                      fbImgUrl="https://dufzo4epsnvlh.cloudfront.net/image/signup/facebook-login.svg"
                      onSocialSubmit={this.onSocialSubmit.bind(this)}
                      onSocialError={this.onSocialError.bind(this)}
                      page="login"
                    />
                  ) : null}
                </div>
                <div className={`position-relative ${styles['divider']}`}>
                  <span className={`px-10 position-relative ${styles['divider-text']}`}>or</span>
                </div>
                <div>
                  {!this.state.initializing ? (
                    <Formik
                      validateOnChange={false}
                      validateOnBlur={false}
                      initialValues={{
                        email: this.state.initial_email,
                        password: '',
                        remember_me: false,
                        initial_email: this.state.initial_email,
                        first_name: this.state.firstName,
                        last_name: this.state.lastName,
                        contact_phone: this.state.contactPhone
                      }}
                      validationSchema={Yup.object().shape({
                        email: Yup.string().email('Invalid Email').required('Required'),
                        password: Yup.string().required('Required')
                      })}
                      onSubmit={(values, actions, event) => {
                        this.handleSubmit(values, event)
                      }}
                      render={({ values, setFieldValue }) => {
                        return (
                          <Form id="frmLogin" data-test="login-form">
                            <div className="form-group">
                              <ErrorMessage name="email" component="span" className="form-error ml-0" />
                              <div className="position-relative">
                                <Field
                                  id="formLogin_txtEmail"
                                  className={'form-control form-control-lg mb-20 rounded ' + styles['icon-field']}
                                  type="text"
                                  placeholder="Email Address"
                                  name="email"
                                  value={values.email}
                                  data-test="login-email-field"
                                  onChange={(e) => {
                                    setFieldValue('email', e.target.value.trim())
                                  }}
                                />
                                <div className={'position-absolute ' + styles['prepend-image']}>
                                  <Icon className={styles['stroke-icon']} name="mail" />
                                </div>
                              </div>
                            </div>
                            <div className="form-group position-relative">
                              <ErrorMessage name="password" component="span" className="form-error ml-0" />
                              <div className="position-relative">
                                <Field
                                  id="formLogin_txtPassword"
                                  className={'form-control form-control-lg mb-20 rounded ' + styles['icon-field']}
                                  type={this.state.hidePassword ? 'password' : 'text'}
                                  placeholder="Password"
                                  name="password"
                                  value={values.password}
                                  data-test="login-password-field"
                                />
                                <span
                                  className={`position-absolute cursor-pointer ${styles['prepend-image']}`}
                                  onClick={() => {
                                    this.setState({ hidePassword: !this.state.hidePassword })
                                  }}>
                                  {this.state.hidePassword ? <Icon name="lock" /> : <Icon name="unlock" />}
                                </span>
                              </div>
                            </div>
                            <div className="d-flex justify-content-between mb-20 ">
                              <div className="form-group form-check">
                                <label>
                                  <Field
                                    type="checkbox"
                                    className=""
                                    checked={values.remember_me}
                                    onChange={(event) => {
                                      setFieldValue('remember_me', !values.remember_me)
                                    }}
                                  />
                                  <span className="checkbox-icon"></span>
                                  <span className="ml-10">Remember Me</span>
                                </label>
                              </div>

                              <Link
                                data-test="login-forgot-password"
                                className={`hover-underline ${styles['link']}`}
                                to="/forgot"
                                title="Forgot password">
                                Forgot password?
                              </Link>
                            </div>
                            <button
                              className="btn btn-xl bg-primary btn-block text-white btn-shadow d-flex align-items-center justify-content-center"
                              id="formLogin_btnSignIn"
                              data-test="login-form-sign-in-btn"
                              disabled={this.state.submitting}
                              type="submit">
                              SIGN IN
                              {this.state.submitting && (
                                <img
                                  className="spinner ml-10 position-relative"
                                  src="https://dufzo4epsnvlh.cloudfront.net/image/default.svg"
                                  alt=""
                                />
                              )}
                            </button>
                          </Form>
                        )
                      }}
                    />
                  ) : null}
                </div>
              </div>
            }
            {domainSettings && domainSettings.generalSettings && domainSettings.generalSettings.can_register ? (
              <div className="information-text d-block pt-15 pb-10">
                <p>
                  Need a GoSite account?{' '}
                  <Link
                    id="signup-link"
                    to={`/signup${this.props.location.search}`}
                    className={styles['link']}
                    title="Sign up">
                    Create an account
                  </Link>
                </p>
              </div>
            ) : null}
            <div className={styles['footer-copyright']}>
              <div className="information-text text d-flex align-items-center justify-content-center">
                &copy; <span className="mr-5">{new Date().getFullYear()}</span>
                <span className={'rounded-circle d-inline-block ' + styles['dot']}></span>
                <a
                  className={'d-inline-block mx-5 ' + styles['foot-link']}
                  title="Terms of Service"
                  href="https://www.gosite.com/terms-of-service"
                  target="_blank"
                  rel="noopener noreferrer">
                  Terms of Service
                </a>
                <span className={'rounded-circle d-inline-block ' + styles['dot']}></span>
                <a
                  className={'d-inline-block mx-5 ' + styles['foot-link']}
                  title="View privacy policy"
                  href="https://www.gosite.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer">
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
          {this.state.showTwoFAPopup ? (
            <TwoFactorPopup
              open={this.state.showTwoFAPopup}
              user={this.state.twoFactorData}
              close={() => {
                this.setState({ showTwoFAPopup: false, twoFactorData: null })
              }}
              onResendtOtp={this.onResendtOtp.bind(this)}
              verifyOtp={this.verifyOtp.bind(this)}
              apiError={this.props.apiError}
              clearApiError={this.props.clearApiError}
            />
          ) : null}
        </div>
      )
    )
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Login)
